import { useId } from "react";
import "./tooltipAyuda.css";

/**
 * Punto único de integración para las ayudas contextuales de la aplicación.
 * Si en el futuro se adopta una librería de tooltips, alcanza con reemplazar
 * la implementación interna de este componente.
 */
export default function TooltipAyuda({ contenido, etiqueta = "Más información", posicion = "arriba" }) {
  const tooltipId = useId();

  if (!contenido) return null;

  return <span className={`tooltip-ayuda tooltip-ayuda--${posicion}`}>
    <button
      type="button"
      className="tooltip-ayuda__disparador"
      aria-label={etiqueta}
      aria-describedby={tooltipId}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
      }}
    >
      <i className="pi pi-info-circle" aria-hidden="true" />
    </button>
    <span id={tooltipId} className="tooltip-ayuda__contenido" role="tooltip">
      {contenido}
    </span>
  </span>;
}
